import {
    lazyAddMasterCategories,
    lazyChangeMasterCategories,
    getMasterCategoryList,
} from 'owa-categories';
import CategoryType from 'owa-service/lib/contract/CategoryType';
import { action } from 'satcheljs/lib/legacy';

export let addCategory = action('addCategory')(async function addCategory(
    id: string,
    name: string,
    colorId: number
) {
    let masterList = getMasterCategoryList();
    let matchingCategories = masterList.filter(existingCategory => existingCategory.Id === id);

    if (matchingCategories.length > 0) {
        throw new Error('addCategory: Cannot add a category that already exists');
    }

    // No matching category, add a new one
    let categoryToAdd = <CategoryType>{
        Name: name,
        Color: colorId,
        Id: id,
    };
    const addMasterCategories = await lazyAddMasterCategories.import();
    addMasterCategories([categoryToAdd], 'CategoriesOptions');
});

export let updateExistingCategoryColor = action('updateCategory')(async function updateCategory(
    id: string,
    colorId: string
) {
    let masterList = getMasterCategoryList();
    let matchingCategories = masterList.filter(existingCategory => existingCategory.Id === id);

    if (matchingCategories.length != 1) {
        throw new Error('UpdateCategoryColor should be called on an existing color');
    }

    let newColorId = +colorId;
    if (matchingCategories[0].Color == newColorId) {
        return;
    }

    matchingCategories[0].Color = newColorId;

    lazyChangeMasterCategories.importAndExecute([matchingCategories[0]], 'CategoriesOptions');
});
